// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2c7h-","innerHeader":"header_innerHeader__3gT2z","languageContainer":"header_languageContainer__1BYo8","navContainer":"header_navContainer__3mMVP"};